<template>
    <div class="card-wrapper" :class="cardWrapperClasses">
        <!-- Card Content -->
        <div class="card quick-class flex-grow-1">
            <div class="card-body" :class="cardBodyClasses">
                <div v-if="draggable" class="drag-handle">
                    <span class="drag-icon">&#9776;</span> <!-- Unicode character for '≡' -->
                </div>

                <a :href="quickClass.uri" class="d-flex h-100 flex-column" :class="cardBodyClasses">
                    <div class="img-wrap p-0" :class="imgWrapClasses">
                        <div class="img-container">
                            <div class="free badge badge-success" v-if="quickClass.is_free">
                                Watch for Free
                            </div>
                            <div class="video-length" v-if="quickClass.video">
                                {{ quickClass.video.durationFormatted }}
                            </div>
                            <img
                                class="card-img-top-virtuoso"
                                :src="quickClass.imageUris ? quickClass.imageUris.cardThumb.url : ''"
                                :alt="quickClass.name"
                                loading="lazy"
                                :class="{ 'mb-0': horizontalMobile }"
                            />

                            <template v-if="quickClass.progress">
                                <div class="progress">
                                    <div class="progress-bar" role="progressbar" :style="'width:'+ progressPercentage +'%;'"></div>
                                </div>
                            </template>
                        </div>
                    </div>

                    <div class="content-wrap" :class="contentWrapClasses">
                        <h2 class="card-title mb-2">{{ quickClass.name }}</h2>
                        <div class="teacher-list grey-subtitle" v-if="quickClass.teacher">
                            {{ quickClass.teacher.name }}
                        </div>
                        <p class="card-text black-text mb-0 text-truncate-ellipsis">
                            {{ quickClass.card_excerpt }}
                        </p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        quickClassData: {
            type: Object,
            default: null,
        },
        stacked: {
            type: Boolean,
            default: false,
        },
        horizontal: {
            type: Boolean,
            default: false,
        },
        horizontalMobile: {
            type: Boolean,
            default: false,
        },
        hasContentMenu: {
            type: Boolean,
            default: false,
        },
        draggable: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            quickClass: {},
            progressPercentage: 0,
        };
    },

    mounted() {
        this.quickClass = this.quickClassData;

        if(this.quickClass.progress) {
            this.progressPercentage = this.quickClass.progress;
        }
    },

    computed: {
        cardWrapperClasses() {
            return {
                'stacked': this.stacked,
                'd-flex align-items-center': this.draggable,
                'd-flex flex-row': !this.draggable,
                'has-content-menu': this.hasContentMenu,
                'horizontal-mobile': this.horizontalMobile,
                'horizontal': this.horizontal,
                'with-progress': this.quickClass.progress,
            };
        },
        cardBodyClasses() {
            return {
                'flex-md-row': this.horizontal,
                'flex-row': this.horizontalMobile,
            };
        },
        imgWrapClasses() {
            if (this.horizontalMobile) {
                return 'col-5';
            } else if (this.horizontal) {
                return 'col-12 col-md-5';
            } else {
                return '';
            }
        },
        contentWrapClasses() {
            let classes = 'd-md-flex flex-column';
            if (this.horizontalMobile) {
                classes += ' col-7 px-0 px-3';
            } else if (this.horizontal) {
                classes += ' col-12 col-md-7 px-0 px-md-3';
            }
            return classes;
        },
    },
};
</script>

<style scoped>
.drag-handle {
    width: 30px; /* Adjust width as needed */
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: move; /* Show move cursor to indicate draggable area */
    padding-right: 10px;
}

.drag-icon {
    font-size: 18px; /* Adjust as needed */
    color: #A0A0A0;
}
</style>
